import './style.scss';
const ImageSelector = ({ options, value, onChange }) => {
	return (
		<div className="template-selector">
			{options.map((option) => (
				<button
					key={`${option.value}-${option.label}`}
					className={`template-item ${
						value === option.value ? 'selected' : ''
					}`}
					onClick={() => onChange(option.value, option.templateId)}
				>
					<img
						src={option.imageUrl}
						alt={option.label}
						title={option.label}
					/>
					<div className="image-label">{option.label}</div>
					<div className="checkmark">✓</div>
				</button>
			))}
		</div>
	);
};

export default ImageSelector;